<template>
  <div>
    <slot name="avatar">

      <v-menu offset-x open-on-hover :close-on-content-click="false" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            v-on="on"
          >
            <v-icon>mdi-package-variant</v-icon>
          </v-btn>
        </template>
        <v-card>
          <!-- MAIN VIEW -->
          <div class="pa-4">
            <div>
              {{ definition.name }}
            </div>
            <div class="caption">
              <span class="textSecondary--text">definition_id:</span> {{ definition.id }}
            </div>
            <router-link :to="{ path: '/inventory/inventory-definition/view/' + definition.id }" target="_blank" class="caption">
              open in a new page
            </router-link>
          </div>
        </v-card>
      </v-menu>
    </slot>
    &nbsp;
    <slot name="name">
      <text-highlight  :queries="nameKeywords" highlightClass="highlight-class" highlightStyle="">{{ definition.name }}</text-highlight>
    </slot>
  </div>
</template>

<script>
import TextHighlight from 'vue-text-highlight'

export default {
  props: {
    definition: {},
    searchString: null
  },
  components: {
    TextHighlight
  },
  computed: {
    nameKeywords () {
      return (this.searchString || '').trim().split(/\s+/)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .highlight-class {
  background: var(--v-color1-base);
  color: white;
}
</style>